var o = /* @__PURE__ */ ((e) => (e.LARGE = "large", e.MEDIUM = "medium", e.SMALL = "small", e.TINY = "tiny", e))(o || {}), u = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.INVIS = "invis", e.LARGE = "large", e))(u || {}), t = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e))(t || {}), l = /* @__PURE__ */ ((e) => (e.primary = "primary", e.subtle = "subtle", e))(l || {});
function h(e) {
  return e === "invis" ? "dropdown-divider-invis" : e === "large" ? "dropdown-divider-large" : "";
}
function a(e, s, d, i) {
  var n;
  const r = ["dropdown", "dropdown-max-height"];
  return e.bordered === "primary" && r.push("dropdown-bordered-primary"), e.bordered === "subtle" && r.push("dropdown-bordered"), s === "left" && r.push("dropdown-left"), s === "right" && r.push("dropdown-right"), d === "up" && r.push("dropdown-up"), e.searchField && r.push("dropdown-with-search"), i && r.push("shown"), e.hideIndicator && r.push("dropdown-hide-indicator"), (n = e.dropdownElementClass) != null && n.includes("select-custom-dropdown") && (d === "up" ? r.push("select-custom-dropdown-up") : r.push("select-custom-dropdown-down"), e.bordered === "primary" && r.push("select-custom-dropdown-outline")), r.join(" ") + ` ${e.dropdownElementClass}`;
}
function p(e) {
  const s = ["dropdown-sections"];
  return e.searchField && s.push("has-search"), s.join(" ");
}
export {
  o as DropdownActivatorSize,
  u as DropdownDivider,
  t as DropdownIndicator,
  l as EDropdownBorders,
  h as getDropdownDividerStyleClasses,
  p as getDropdownSectionClasses,
  a as getDropdownStyleClasses
};
